<template>
  <div class="b-tooltips">
    <!-- <b-tooltip multilined :label="display" type="is-dark"> -->
    <a @mouseover="fetchIfNeeded" @click="toggleModal" class="is-block">
      <span class="fetch-placeholder" v-if="!fetched">{{ id }}</span>
      <transition name="fade">
        <span class="fetch-content" v-if="fetched"
          >{{ data.title }} <br />
          <small>{{ data.subtitle }}</small></span
        >
      </transition>
    </a>
    <!-- </b-tooltip> -->
    <b-modal
      :active="isModalOpen"
      @close="() => (isModalOpen = false)"
      :width="640"
    >
      <div class="card" v-if="fetched">
        <div class="card-content has-text-left">
          <!-- <div class="columns">
            <div class="column">
              <figure class="image is-16by9">
                <img
                  :src="`https://assets.urlaubsgutschein.kaufen/${data.image}`"
                  alt="Image"
                />
              </figure>
            </div>
            <div class="column">

            </div>
          </div> -->
          <div class="content">
            <h2 class="title is-4">{{ data.title }}</h2>
            <p class="subtitle is-6">{{ data.subtitle }}</p>
          </div>

          <h3 class="title is-5">Varianten</h3>
          <ul class="columns is-multiline is-variable is-3">
            <li
              v-for="variant in data.variants"
              :key="variant.id"
              class="column is-4"
            >
              <div class="box has-background-white-ter">
                <div class="columns is-mobile is-multiline">
                  <div class="column is-12-tablet">
                    <span class="is-inline-block"
                      >{{ variant.nights }} Nächte</span
                    >,
                    <span class="is-inline-block"
                      >{{ variant.persons }} Personen</span
                    >,<br />
                    <span class="is-inline-block">{{
                      variant.board.longName
                    }}</span>
                  </div>
                  <div class="column has-text-right is-12-tablet">
                    <small>{{ variant.price.currency }}</small
                    >&nbsp;
                    <strong class="is-size-5">{{ variant.price.total }}</strong>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="content">
            <h3 class="title is-5">Leistungsumfang</h3>
            <p class="services">
              {{ data.services }}
            </p>

            <b-notification :closable="false">
              <h3 class="title is-5">Gültigkeit</h3>
              <p>{{ data.validity }}</p>
            </b-notification>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import offersApi from '@/api/offers-api'
export default {
  name: 'OfferIdTooltip',
  props: {
    id: String,
  },
  methods: {
    fetchIfNeeded: async function() {
      if (!this.fetched) {
        const obj = await offersApi.getById(this.id)
        this.data = obj
        this.display = `${obj.title} - ${obj.contact.name}`
        this.fetched = true
      }
    },
    toggleModal() {
      this.isModalOpen = !this.isModalOpen
    },
  },
  data() {
    return {
      display: 'Bitte Warten, daten werden geladen...',
      data: {},
      fetched: false,
      isModalOpen: false,
    }
  },
  watch: {
    id: function(val) {
      if (val && this.fetched && this.data.id != val) {
        this.fetched = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.services {
  white-space: pre-wrap;
}

.fade-enter,
.fade-leave {
  transition: all ease-in-out 200ms;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
